//messages
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const SET_MESSAGE = "SET_MESSAGE";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const SET_INDICATE = "SET_INDICATE";
export const TOGGLE_MESSAGE = "TOGGLE_MESSAGE";

//socket
export const SET_CONNECTION = "SET_CONNECTION";



// WEBPACK FOOTER //
// ./src/messages/constants.js